// 左側「報價單」底下的二級選單:全部 / 已結案 / 未結案(業主 2026-10-15)。
//
// 它不是另一套篩選,是「分類」的快捷鍵:點了就把**狀態那一群**換掉
// (全部 = 狀態群清空),收款群(未收款 / 已收款)原樣留著,存回帳號 ——
// 與分類器同一份設定,下次進來還是同一個。
//
// 側邊欄與列表是兩個元件,靠 `QUOTE_CATEGORIES_CHANGED` 事件對齊:
// 任何一邊存了新的分類就廣播,另一邊跟著換,不必各自再問一次後端。

import { api } from "../../api/client";
import type { ListCategorySettings } from "./CategoryPicker";

export type QuoteView = "ALL" | "CLOSED" | "OPEN";

export const QUOTE_VIEWS: { key: QuoteView; label: string }[] = [
  { key: "ALL", label: "全部" },
  { key: "CLOSED", label: "已結案" },
  { key: "OPEN", label: "未結案" },
];

/** 分類的狀態群(與後端 `quote_categories.STATUS_GROUP` 同一組)。 */
const STATUS_GROUP = ["DRAFT", "SENT", "OPEN", "CLOSED"];

export const QUOTE_CATEGORIES_CHANGED = "quote-categories-changed";

export function announceCategories(next: string[]): void {
  window.dispatchEvent(new CustomEvent<string[]>(QUOTE_CATEGORIES_CHANGED, { detail: next }));
}

/** 換掉狀態群,收款群留著。 */
export function withView(current: string[], view: QuoteView): string[] {
  const kept = current.filter((key) => !STATUS_GROUP.includes(key));
  return view === "ALL" ? kept : [view, ...kept];
}

/** 目前的分類對得上哪一個快捷;自己在分類器勾了別的組合就是 null(哪一個都不亮)。 */
export function viewOf(categories: string[]): QuoteView | null {
  const status = categories.filter((key) => STATUS_GROUP.includes(key));
  if (status.length === 0) return "ALL";
  if (status.length === 1 && (status[0] === "CLOSED" || status[0] === "OPEN")) return status[0];
  return null;
}

/** 讀目前的分類、換掉狀態群、存回去、廣播。回傳存好的那一份。 */
export async function saveView(view: QuoteView): Promise<string[]> {
  const settings = await api.get<ListCategorySettings>("/users/me/list-categories");
  const next = withView(settings?.quote_list_categories ?? [], view);
  const saved = await api.put<ListCategorySettings>("/users/me/list-categories", { quote_list_categories: next });
  const got = saved?.quote_list_categories ?? next;
  announceCategories(got);
  return got;
}
